import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@mui/material';

import { times } from 'lodash';

import { sectionPayloadShape, sectionSubmissionShape } from '../../types';

import OneOf from './questions/OneOf';
import MultipleChoice from './questions/MultipleChoice';
import IntegerPercentage from './questions/IntegerPercentage';
import ArbitraryString from './questions/ArbitraryString';
import TrialOpenQuestion from '../trial/TrialOpenQuestion';
import FirstColumnContainer from './questions/FirstColumnContainer';

export default class SurveySection extends Component {
  renderQuestion = (question, numCases, startCase, onSamplePayloadChanged) => {
    const { sectionSubmission } = this.props;
    const disabled = (sectionSubmission && sectionSubmission.discardSubmission) || false;
    const questionUuid = question.question.uuid;
    const submissionPayload = sectionSubmission
      && sectionSubmission.questions
      && sectionSubmission.questions[questionUuid];
    if (
      this.props.excludedQuestionSection
      && this.props.excludedQuestionSection.indexOf(questionUuid) > -1
    ) {
      return '';
    }
    switch (question.type) {
      case 'OneOf':
        return (
          <OneOf
            key={`OneOf-${questionUuid}-${startCase}`}
            numCases={numCases}
            startCase={startCase}
            answerPayload={submissionPayload}
            onSamplePayloadChanged={onSamplePayloadChanged}
            getSubmissionAnswer={this.props.getSubmissionAnswer}
            disabled={disabled}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...question}
          />
        );
      case 'IntegerPercentage':
        return (
          <IntegerPercentage
            key={`IntegerPercentage-${questionUuid}-${startCase}`}
            numCases={numCases}
            startCase={startCase}
            answerPayload={submissionPayload}
            onSamplePayloadChanged={onSamplePayloadChanged}
            getSubmissionAnswer={this.props.getSubmissionAnswer}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...question}
          />
        );
      case 'MultipleChoice':
        return (
          <MultipleChoice
            numCases={numCases}
            startCase={startCase}
            key={`MultipleChoice-${questionUuid}-${startCase}`}
            onSamplePayloadChanged={onSamplePayloadChanged}
            answerPayload={submissionPayload}
            disabled={disabled}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...question}
          />
        );
      case 'ArbitraryString':
        return (
          <ArbitraryString
            key={`IntegerPercentage-${questionUuid}-${startCase}`}
            numCases={numCases}
            startCase={startCase}
            answerPayload={submissionPayload}
            onSamplePayloadChanged={onSamplePayloadChanged}
            getSubmissionAnswer={this.props.getSubmissionAnswer}
            printFlag={this.props.printFlag}
            disabled={disabled}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...question}
          />
        );
      default:
        return <div>{`Unknown type of question: ${question.type}`}</div>;
    }
  };

  renderHeader = (numSamples, startCase, headline, caseNames) => {
    const bacgkroundColor = 'bg-light-gray';
    return (
      <div className={`mb2 flex nowrap ${bacgkroundColor}`}>
        {
          !this.props.printFlag
          && (
          <FirstColumnContainer className={`self-end ${bacgkroundColor}`} style={{ whiteSpace: 'pre-wrap' }}>
            {
              headline ? (
                <span
                  className={`self-end ${bacgkroundColor}`}
                  style={{ minWidth: 400, whiteSpace: 'pre-wrap' }}
                >
                  {headline}
                </span>
              )
                : <span />
            }
          </FirstColumnContainer>
          )
        }
        <ul className={`flex ma0 list nowrap pl0 basis-100 ${bacgkroundColor}`}>
          {
            times(numSamples, (index) => (
              <li
                key={`sample-title-${index + startCase}`}
                className={`mr2 mb2 mt2 basis-100 w2 flex justify-center ${bacgkroundColor}`}
              >
                <p className="basis-100 mb0 tc">
                  {(caseNames && caseNames[index]) || `P${index + 1}`}
                </p>
              </li>
            ))
          }
        </ul>
      </div>
    );
  };

  renderMainQuestions = (startCase, onSamplePayloadChanged) => {
    const {
      questions, numCases, headline, caseNames,
    } = this.props.payload;
    return (
      <Paper variant="outlined" className="overflow-x-auto pa2 mb4">
        {this.renderHeader(numCases, startCase, headline, caseNames)}
        {
          questions.map((question) => this.renderQuestion(
            question, numCases, startCase, onSamplePayloadChanged,
          ))
        }
      </Paper>
    );
  };

  renderContextQuestions = (contextQuestions, onAnswerChanged) => {
    const { sectionSubmission } = this.props;
    const disabled = (sectionSubmission && sectionSubmission.discardSubmission) || false;
    return contextQuestions.map((sectionQuestion) => (
      <TrialOpenQuestion
        key={sectionQuestion.question.uuid}
        question={sectionQuestion}
        answers={
          sectionSubmission
          && sectionSubmission.context
          && sectionSubmission.context[sectionQuestion.question.uuid]
        }
        onChange={(answers) => {
          onAnswerChanged(sectionQuestion.question.uuid, answers);
        }}
        disabled={disabled}
      />
    ));
  };

  render() {
    const {
      show,
      payload,
      startCase,
      onSamplePayloadChanged,
      onContextQuestionAnswer,
    } = this.props;

    const sectionStyle = { display: show ? 'block' : 'none' };
    return (
      <div className="ma1 mb3" style={sectionStyle}>
        {this.renderMainQuestions(startCase, onSamplePayloadChanged)}
        {
          (payload.contextQuestions && onContextQuestionAnswer)
          && this.renderContextQuestions(payload.contextQuestions, onContextQuestionAnswer)
        }
      </div>
    );
  }
}

SurveySection.defaultProps = {
  sectionSubmission: undefined,
  getSubmissionAnswer: undefined,
  onContextQuestionAnswer: undefined,
  show: true,
  excludedQuestionSection: undefined,
  printFlag: undefined,
};

SurveySection.propTypes = {
  payload: sectionPayloadShape.isRequired,
  startCase: PropTypes.number.isRequired,
  onSamplePayloadChanged: PropTypes.func.isRequired,
  sectionSubmission: sectionSubmissionShape,
  getSubmissionAnswer: PropTypes.func,
  onContextQuestionAnswer: PropTypes.func,
  show: PropTypes.bool,
  excludedQuestionSection: PropTypes.arrayOf(PropTypes.string),
  printFlag: PropTypes.bool,
};
